import { useEffect, useRef, useState } from "react";
import NewToolTip from "../NewToolTip";
import classes from "./urgent-hiring.module.css";
import cx from "classnames";
import LogService from "../../services/LogService";
import CREDIT_EVENTS from "../../utils/CreditEvents";
import Animation from "../../Animations";
import urgetHiringNew from "../../Animations/lottie-files/urgentHiringNew2.json";

function UrgentHiring(props) {
  const { toolTipUrgentHiring, tipClass } = props;
  const [showUrgentHiringTooltip, setUrgentHiringTooltip] = useState(false);

  const urgentHiringRef = useRef(null);

  const onUrgentHiringClick = e => {
    // const element = urgentHiringRef.current;
    // const headerOffset = 120;
    // const elementPosition = element.getBoundingClientRect().top;
    // const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    // window.scrollTo({
    //   top: offsetPosition,
    //   behavior: "smooth"
    // });

    e.stopPropagation();
    setUrgentHiringTooltip(true);
  };

  useEffect(() => {
    if (showUrgentHiringTooltip) {
      LogService.log(CREDIT_EVENTS.URGENT_HIRING_HOVER_POPUP_SHOWN, {
        path: window.location.pathname
      });
    }
  }, [showUrgentHiringTooltip]);


  return (
    <div ref={urgentHiringRef} className={classes.root}>
      <img
        src="/hire/urgent-hiring-info.svg"
        width={16}
        height={16}
        alt="urgent-hiring-info icon"
        className={classes.urgentHiringIcon}
        onClick={e => onUrgentHiringClick(e)}
        onMouseOver={e => onUrgentHiringClick(e)}
      />
      {showUrgentHiringTooltip && (
        <NewToolTip
          rootClass={
            toolTipUrgentHiring
              ? cx(toolTipUrgentHiring, classes.toolTipUrgentHiring)
              : classes.toolTipUrgentHiring
          }
          tipClass={
            tipClass ? cx(tipClass, classes.tipClass) : classes.tipClass
          }
          isClose={false}
          showTip={true}
          handleClose={() => setUrgentHiringTooltip(false)}
          tipUrl={"/hire/tipUp.svg"}
          keepScrollEvent={false}
          keepOutsideClickEvent={false}
        >
          <div className={classes.tipContainer}>
            <div
              className={classes.close}
              onClick={() => setUrgentHiringTooltip(false)}
            >
              <img
                src="/hire/close_gray.svg"
                height={12}
                width={12}
                alt="close icon"
              />
            </div>
            <div className={classes.urgentHiringWarning}>
              <img
                src="/hire/warning-clock.svg"
                width={12}
                height={12}
                alt="warning clock icon"
                className={classes.clockIcon}
              />
              Urgent Hiring!
            </div>
            <div className={classes.heading}>
              Your job will be posted with an {`'Urgent Hiring'`} tag.
            </div>
            <div className={classes.animation}>
              <Animation file={urgetHiringNew} loop={true} />
            </div>
          </div>
        </NewToolTip>
      )}
    </div>
  );
}

export default UrgentHiring;
